"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderReceiveScan = void 0;
const core_1 = require("@material-ui/core");
const ndc_barcode_scan_1 = require("client/components/ndc-barcode-scan");
const material_ui_1 = require("material-ui");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./order-receive-scan.less");
const styles = core_1.createStyles({
    rowDetails: {
        padding: "12px 16px",
        flex: "1 0 120px"
    },
    invalid: {
        background: "rgba(193, 30, 30, 0.05)"
    },
    invalidMessage: {
        marginTop: "15px",
        color: "red"
    }
});
const decorate = core_1.withStyles(styles);
let OrderReceiveScanUnstyled = class OrderReceiveScanUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.renderPreview = (ndcScan) => {
            const { orderInventories } = this.props.purchaseOrder;
            const [ndc, scannedArray] = ndcScan;
            const poInventory = orderInventories.find((poi) => poi.pkgCode === ndc);
            const ndcNotInPo = !poInventory;
            if (ndcNotInPo) {
                return (React.createElement("div", { className: this.props.classes.rowDetails },
                    React.createElement(material_ui_1.Typography, null, "NDC not found in purchase order and will not be processed.")));
            }
            const { inventoryOrderQuantity, totalQtyReceived: currentTotalQtyReceived } = poInventory;
            const currentReceivedQty = scannedArray.length;
            const newTotalReceivedQty = currentTotalQtyReceived + currentReceivedQty;
            const allWillBeReceived = newTotalReceivedQty >= inventoryOrderQuantity;
            const previewData = {
                orderQty: inventoryOrderQuantity,
                receivedQty: poInventory.totalQtyReceived,
                scannedQty: scannedArray.length,
                newReceivedQty: newTotalReceivedQty,
                allWillBeReceived
            };
            const { orderQty, receivedQty, scannedQty, newReceivedQty } = previewData;
            const exceedsOrderQty = newReceivedQty > orderQty;
            return (React.createElement("div", { className: this.props.classes.rowDetails },
                React.createElement("div", null,
                    React.createElement(material_ui_1.Typography, null,
                        "Order Qty: ",
                        orderQty),
                    React.createElement(material_ui_1.Typography, null,
                        "Received Qty: ",
                        receivedQty),
                    React.createElement(material_ui_1.Typography, null,
                        "Scanned Qty: ",
                        scannedQty),
                    React.createElement(material_ui_1.Typography, { className: exceedsOrderQty ? this.props.classes.invalid : "" },
                        "New Qty: ",
                        newReceivedQty,
                        " ",
                        exceedsOrderQty ? "(Exceeds order qty)" : ""),
                    exceedsOrderQty ? (React.createElement(material_ui_1.Typography, { className: this.props.classes.invalidMessage }, "*New qty received exceeds order qty.")) : null)));
        };
        this.handleSubmit = async (scannedList) => {
            const { orderInventories } = this.props.purchaseOrder;
            const submitMetas = [];
            for (const [ndc, scannedArray] of scannedList) {
                if (!ndc) {
                    continue;
                }
                const poInventory = orderInventories.find((poi) => poi.pkgCode === ndc);
                if (!poInventory) {
                    console.error("poInventory not found... in handlesubmit");
                    continue;
                }
                const { inventoryOrderQuantity, totalQtyReceived: currentTotalQtyReceived } = poInventory;
                const currentReceivedQty = scannedArray.length;
                const newTotalReceivedQty = currentTotalQtyReceived + currentReceivedQty;
                const allWillBeReceived = newTotalReceivedQty >= inventoryOrderQuantity;
                const lotNumber = scannedArray && scannedArray.length ? scannedArray[0].lot : null;
                const lotExp = scannedArray && scannedArray.length ? scannedArray[0].exp : null;
                const meta = {
                    ndc,
                    lotNumber,
                    lotExp,
                    poInventory,
                    currentReceivedQty,
                    currentTotalQtyReceived,
                    inventoryOrderQuantity,
                    newTotalReceivedQty,
                    allWillBeReceived
                };
                submitMetas.push(meta);
                await this.props.onSubmit(submitMetas);
            }
        };
    }
    render() {
        return (React.createElement(ndc_barcode_scan_1.NdcBarcodeScan, { onCancel: this.props.onCancel, onSubmit: this.handleSubmit, renderPreview: this.renderPreview }));
    }
};
OrderReceiveScanUnstyled = __decorate([
    mobx_react_1.observer
], OrderReceiveScanUnstyled);
exports.OrderReceiveScan = decorate(OrderReceiveScanUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/order-receive-scan/order-receive-scan.tsx
// module id = 3576
// module chunks = 0